import { EditingLayer } from "fond/types";

import { NodeTopologyConfig } from "../topologyHelper";

import { makeOnAfterDragAerial } from "./onAfterDragAerial";
import { makeOnCreateAerialPole } from "./onCreateAerialPole";
import { makeOnTrashAerial } from "./onTrashAerial";

type AerialEditCallbacks = {
  point: Pick<Required<EditingLayer>, "onCreate" | "onAfterDrag" | "onTrash">;
};

/**
 * EditingLayer callbacks for a pole layer.
 */
export const makeAerialEditCallbacks = (config: NodeTopologyConfig): AerialEditCallbacks => ({
  point: { onCreate: makeOnCreateAerialPole(config), onAfterDrag: makeOnAfterDragAerial(config), onTrash: makeOnTrashAerial(config) },
});
